<script setup lang="ts">
  import { trans } from '@bv/utils/i18n.js';
  import { storeToRefs } from 'pinia';
  import { ref, watch } from 'vue';

  import { useCallCenterStore } from '@/stores/call-center/call-center.store';

  import CallCenterInfoModal from './CallCenterInfoModal.vue';

  const callCenterStore = useCallCenterStore();

  const { lastEndedCall } = storeToRefs(callCenterStore);

  const showNotLinkedChannelPopup = ref(false);
  const showNotSavedNumberPopup = ref(false);

  watch(lastEndedCall, (endedCall) => {
    if (!endedCall) {
      return;
    }

    if (endedCall.isNumberSaved === false) {
      showNotSavedNumberPopup.value = true;
    } else if (endedCall.isChannelConnected === false) {
      showNotLinkedChannelPopup.value = true;
    }

    callCenterStore.resetLastCall();
  });
</script>

<template>
  <call-center-info-modal
    v-if="showNotSavedNumberPopup"
    :cancel-text="trans('call_center.limited_call_details_modal.cancel_trans')"
    :confirm-text="trans('call_center.limited_call_details_modal.confirm_trans')"
    :description="trans('call_center.limited_call_details_modal.description_trans')"
    :link-description="trans('call_center.limited_call_details_modal.create_description_trans')"
    :title="trans('call_center.limited_call_details_modal.title_trans')"
    @close="showNotSavedNumberPopup = false"
  />

  <call-center-info-modal
    v-if="showNotLinkedChannelPopup"
    :cancel-text="trans('call_center.call_logged_modal.cancel_trans')"
    :confirm-text="trans('call_center.call_logged_modal.confirm_trans')"
    :description="trans('call_center.call_logged_modal.description_trans')"
    :link-description="trans('call_center.call_logged_modal.link_description_trans')"
    :title="trans('call_center.call_logged_modal.title_trans')"
    @close="showNotLinkedChannelPopup = false"
  />
</template>
